import React, {useState} from "react";
import {connect} from "react-redux";
import Panel from "../../panel/Panel";
import Form from "./forms/Edit";
import {removeAction as removePanelAction} from "../../../actions/panel";
import { InsuranceOutlined } from '@ant-design/icons';
import { Button, Divider, Result, Spin } from "antd";
import GroupList from "./group/List";
import ServiceList from "./service/List";
import EntityLoader from "../../common/EntityLoader";

const Title = ({entity}) => <span>
    <InsuranceOutlined /> {!!entity ? entity.name : '404 - Not Found'}
</span>;

const Content = connect(
    null,
    dispatch => ({
        onRemovePanel: (uniqueKey) => dispatch(removePanelAction(uniqueKey)),
    })
)(({entity, entityId, onRemovePanel}) => <>
    {entity
        ? <>
            <Form siteId={entityId}/>
            <Divider/>
            <GroupList siteId={entityId}/>
            <Divider/>
            <ServiceList siteId={entityId}/>
        </>
        : <Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
            extra={<Button type="primary" onClick={() => onRemovePanel(`cookieconsentsites:${entityId}:edit`)}>close</Button>}
        />
    }
</>);

export default ({siteId}) => {
    const [loading, setLoading] = useState(true);

    return <Panel
        backgroundColor="#882f9c"
        id={`cookieconsentsites:${siteId}:edit`}
        title={
            <EntityLoader entityId={siteId}>
                <Title/>
            </EntityLoader>
        }
    >
        <Spin spinning={loading}>
            <EntityLoader entityId={siteId} onFinally={() => setLoading(false)}>
                <Content/>
            </EntityLoader>
        </Spin>
    </Panel>
};
